import * as types from './mutation-types'

export const login = ({commit}, payload) => {
    commit(types.LOG_IN, payload)
};
// export function login(context) {
//     context.commit(types.LOG_IN)
// }

export const loginSuccess = ({commit}, payload) => {
    commit(types.LOG_IN_SUCCESS, payload)
};

export const loginFailed = ({commit}, payload) => {
    commit(types.LOG_IN_FAILED, payload)
};

export const logout = ({commit}) => {
    commit(types.LOG_OUT)
};